import type { ReactNode } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import QuickJoinPage from './pages/QuickJoin';
import HubPage from './pages/Hub';
import AdminPage from './pages/Admin';

const standaloneAdmin = import.meta.env.VITE_STANDALONE_ADMIN === 'true';

function SiteShell({ children }: { children: ReactNode }) {
  return (
    <div className="site">
      <header className="site-header">
        <div className="site-nav">
          <a className="site-brand" href="/">
            <img src="/app/brand/rvlry-horizontal.png" alt="RVLRY" style={{ height: '32px', width: 'auto' }} />
          </a>
          <nav className="site-links" aria-label="Primary">
            <a className="site-link" href="https://rvlryapp.com/app/support.html">Support</a>
            <a className="site-link" href="https://rvlryapp.com/app/privacy.html">Privacy</a>
          </nav>
        </div>
      </header>
      <main className="site-main">{children}</main>
      <footer className="site-footer">
        <div className="footer-inner">
          <div className="footer-row">
            <div>
              <strong>Need help?</strong> Email <a className="footer-link" href="mailto:support@rvlryapp.com">support@rvlryapp.com</a>
            </div>
            <div className="footer-links">
              <a href="https://rvlryapp.com/app/support.html">Support</a>
              <a href="https://rvlryapp.com/app/terms.html">Terms</a>
              <a href="https://rvlryapp.com/app/privacy.html">Privacy</a>
            </div>
          </div>
          <div className="footer-meta">&copy; 2025 RVLRY. All rights reserved.</div>
        </div>
      </footer>
    </div>
  );
}

export default function App() {
  if (standaloneAdmin) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/app/admin/*" element={<AdminPage />} />
        <Route path="/quick" element={<SiteShell><QuickJoinPage /></SiteShell>} />
        <Route path="/hub" element={<SiteShell><HubPage /></SiteShell>} />
        <Route path="*" element={<Navigate to="/quick" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
